import axios from "axios";
import API_BASE_URL from "../../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/Coding-Opportunities`;

export const getCodingOpportunitiesPatients = async (page = 1, pageSize = 50) => {
    try {
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        page,
        pageSize
      }
    });
    return response.data; // Será un CareGapPatientPageResultDto
  } catch (error) {
    console.error("Error fetching care gap summary:", error);
    throw error;
  }
};
